import { render, staticRenderFns } from "./ScopeOfWorksItem.vue?vue&type=template&id=e417fd2c&"
import script from "./ScopeOfWorksItem.vue?vue&type=script&lang=js&"
export * from "./ScopeOfWorksItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports